import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { MaritalStatus } from './marital-status.interface';
import { MaritalStatusService } from './marital-status.service';
const service = new MaritalStatusService();

export interface MaritalStatusState {
   maritalStatuses: Array<MaritalStatus>;
}

const MaritalStatusStore: Module<MaritalStatusState, StoreState> = {
   namespaced: true,
   state: {
      maritalStatuses: [],
   },
   getters: {},
   mutations: {
      SET_MARITAL_STATUSES(state, maritalStatuses: Array<MaritalStatus>) {
         state.maritalStatuses = maritalStatuses;
      },
   },
   actions: {
      async getMaritalStatuses(context) {
         return await service.getMaritalStatuses().then((response) => {
            context.commit('SET_MARITAL_STATUSES', response);
            return response;
         });
      },
   },
};

export default MaritalStatusStore;
